module.exports = __webpack_public_path__ + "img/platform_develop.fcfc9943.png";